import { Leg } from "./../types";

export function calculateProfit(positions: Leg[], strikePrice: number): number {
  let profit = 0;
  positions.forEach((position: Leg) => {
    profit +=
      position.call
        ? calculateCallProfit(position, strikePrice)
        : calculatePutProfit(position, strikePrice);
  });
  return profit;
}

function calculateCallProfit(position: Leg, strikePrice: number): number {
  let result = 0;
  if (position.buy) {
    result = (
      (Math.max(0, strikePrice - position.strikePrice) - position.price) *
      position.quantity
    );
  }
  result = (
    Math.min(
      position.price,
      position.strikePrice - strikePrice + position.price
    ) * (-position.quantity)
  );
  return result;
}

function calculatePutProfit(position: Leg, strikePrice: number): number {
  if (position.buy) {
    return (
      (Math.max(0, position.strikePrice - strikePrice) - position.price) *
      position.quantity
    );
  }
  return (
    Math.min(
      position.price,
      position.price - position.strikePrice + strikePrice
    ) * -position.quantity
  );
}
